export default {
  TRIAL: "TRIAL",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  INACTIVE: "INACTIVE",
  COURTESY: "COURTESY",
  AWAITING_REGISTRATION: "AWAITING_REGISTRATION",
  EXPIRED: "EXPIRED",
};
